module.exports = __webpack_public_path__ + "img/Icon-20.3323368f.png";